import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import store from './slices/index';
const Root = () => (_jsx(Provider, Object.assign({ store: store }, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) })));
export default Root;
